/* globals gtag */
function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}
export function initialise() {
    // first lets enumerate the types of ads we need to load
    let ad_types = {};
    document.querySelectorAll('[data-post-load="advert"]').forEach(function(post_load_advert) {
        post_load_advert.insertAdjacentHTML('beforeend','<div class="kms-loader recaptcha-kms-loader"></div>');
        let ad_type = post_load_advert.dataset['advertType'];
        if (!(ad_type in ad_types)) {
            ad_types[ad_type] = [];
        }
        ad_types[ad_type].push(post_load_advert);
    });
    let page_url = window.location.pathname;

    //Now we want to get the data for each ad type once
    for (const [type,adverts] of Object.entries(ad_types)) {
        fetch(`/kms/ads/GetAdsByTypeForPage/${type}${page_url}`, {headers: { 'Accept': 'application/json'}})
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(response => response.json())
            .then(data => {
                // populate adverts in random order
                let advert_data = data.ads;
                shuffleArray(advert_data);
                adverts.forEach(advert=> {
                    new Advert(advert,advert_data);
                });
            }).catch((error)=>{
                console.log(`Error loading adverts type: ${type}, url:${page_url} - `, error);                
                adverts.forEach(advert=> {
                    new Advert(advert, null);
                });
            });
    }

}
class Advert{
    constructor(element, advert_data) {
        this.element = element; 
        this.advert_data = advert_data;
        if (advert_data && advert_data.length > 0) {
            this.initialise();
        } else {
            this.element.remove();
        }
    }
    initialise(){
        this.element.href = this.ad.target_url;
        this.element.dataset.adId = this.ad.id;
        this.element.dataset.adName = this.ad.type;
        if (this.ad.targetnew) {
            this.element.setAttribute('rel','noopener');
            this.element.setAttribute('target','_blank');
        }
        this.element.innerHTML = '';
        this.images.map(image => {
            if (image.image_url) {
                this.element.innerHTML += `<img src="${image.image_url}" alt="${image.description}"/>`;
            }
        })
        
        // Track visibility of this ad to trigger this.
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach(entry =>{
                if (entry.isIntersecting) {
                    this.observer.disconnect();
                    this.view();
                }
            })
        },{threshold:0.25});
        this.observer.observe(this.element);
        
    }
    
    view() {        
        // log view to google analytics
        if (gtag) {
            gtag('event', 'advert', {'event_category': 'view', 'event_label': `${this.ad.name}`});
        }
        // TODO: log view to GA4        
    }
    get ad(){
        return this.advert_data[this.adIndex-1];
    }
    get images() {
        return this.ad.ad_image.filter(i=>i.identifier == this.identifier).slice(0,this.count)
    }
    get adIndex(){
        return parseInt(this.element.dataset.advertIndex)
    }
    get identifier() {
        return this.element.dataset.advertIdentifier;
    }
    get count() {
        return this.element.dataset.advertCount;
    }

}



/**** KMS ad manager related client scripts ****/
//Advert link tracking

function adLinkClick(e){
    let el = e.target;
    if (window.gtag) {
        if (this.target=="_blank") {
            window.gtag('event', 'advert', {'event_category' : 'click', 'event_label' : el.dataSet.adName});
            return;
        }
        e.preventDefault();
        var navigated =false;
        var navigate = function(){
            if (!navigated) {
                navigated = true;
                document.location = el.href;
            }
        }
        // Creates a timeout to navigate after one second.
        setTimeout(navigate, 1000);
        window.gtag('event', 'advert', {'event_category' : 'click', 'event_label' :el.dataSet.adName,
        'hitCallback':navigate, 'hitCallbackFail':navigate});
    }
}
document.addEventListener('DOMContentLoaded', function(){
    [...document.querySelectorAll("a.KMS-advert")].forEach((el) => {
        el.addEventListener('click', adLinkClick)
        el.addEventListener('touch', adLinkClick)
    })
});
